import { render, staticRenderFns } from "./DeptInformer.vue?vue&type=template&id=7640816f"
import script from "./DeptInformer.vue?vue&type=script&lang=js"
export * from "./DeptInformer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports